<template>
<zj-layout-container>
  <zj-layout-main>
    <div class="zj-layout-main-content bgcolor scrollable" ref="container">
      停车场
    </div>
  </zj-layout-main>
</zj-layout-container>
</template>

<script>
export default {
  name: 'ZjCarParkHome',
  controller: 'UI',
  action: 'Home'
}
</script>
